module.exports = __webpack_public_path__ + "img/n5.904d78c8.svg";